import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { DatagridComponent } from './datagrid.component';
import { NbCardModule } from '@nebular/theme';

@NgModule({
  imports: [
    CommonModule, Ng2SmartTableModule, NbCardModule
  ],
  declarations: [
    DatagridComponent,
  ],
  exports: [
    DatagridComponent,
  ],
})

export class DatagridModule {}


// WEBPACK FOOTER //
// ./src/app/components/datagrid/datagrid.module.ts